import { type RouteDefinition } from "../../shared/types/routes";
import RoleGuard from "../../core/guards/RoleGuard";
import Profile from "./Profile";
import UserProfile from "./UserProfile";

export const profileRoutes: RouteDefinition[] = [
  { path: "/profile", element: <Profile /> },
  {
    path: "/profile/:userId",
    element: (
      <RoleGuard roles={["admin", "user_manager"]}>
        <UserProfile />
      </RoleGuard>
    ),
  },
];
